import { Card } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import {
  Calendar as CalendarIcon,
  User,
  AlertCircle,
  CheckCircle,
  XCircle,
} from 'lucide-react'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import type { RendezVous } from '@/services/agenda'

interface PendingAppointmentsProps {
  rdvsEnAttente: RendezVous[]
  onConfirm: (rdv: RendezVous) => void
  onDecline: (rdv: RendezVous) => void
  isConfirming: boolean
  isDeclining: boolean
}

export function PendingAppointments({
  rdvsEnAttente,
  onConfirm,
  onDecline,
  isConfirming,
  isDeclining,
}: PendingAppointmentsProps) {
  if (rdvsEnAttente.length === 0) return null

  return (
    <Card>
      <h2 className="text-lg font-semibold text-brown-900 mb-4 flex items-center gap-2">
        <AlertCircle className="w-5 h-5 text-gold-500" />
        Rendez-vous en attente de confirmation ({rdvsEnAttente.length})
      </h2>
      <div className="space-y-3">
        {rdvsEnAttente.map((rdv) => (
          <div
            key={rdv.id}
            className="p-4 border border-gold-200 rounded-lg bg-gold-50 hover:bg-gold-100 transition"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <CalendarIcon className="w-4 h-4 text-gold-600" />
                  <span className="font-medium text-brown-900">
                    {format(new Date(rdv.date_heure), 'PPPp', { locale: fr })}
                  </span>
                </div>
                <div className="flex items-center gap-3 mb-2">
                  <User className="w-4 h-4 text-brown-500" />
                  <span className="text-brown-700">
                    {rdv.client?.full_name || rdv.client?.email || 'Client'}
                  </span>
                </div>
                {rdv.description && (
                  <p className="text-sm text-brown-600 mt-2">{rdv.description}</p>
                )}
              </div>
              <div className="flex gap-2">
                <Button
                  size="sm"
                  variant="primary"
                  onClick={() => onConfirm(rdv)}
                  disabled={isConfirming}
                  leftIcon={<CheckCircle className="w-4 h-4" />}
                >
                  Confirmer
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => onDecline(rdv)}
                  disabled={isDeclining}
                  leftIcon={<XCircle className="w-4 h-4" />}
                >
                  Refuser
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  )
}
